import { objNamesToCamelCase } from "common/utils/helpers/cases";
import store from "../vue-cart/store";

export const provideNewCartsData = ({ customer, number }) => {
  store.commit("setOrderNumber", number);
  store.commit("savedCarts/setSavedCartsCustomer", objNamesToCamelCase(customer));
};

const initSavedCartsEditModalConsumer = async id => {
  const $root = document.querySelector(id);
  if (!$root) return;

  await store.dispatch("savedCarts/loadSavedCarts");
};

export const modalStore = store;

export default initSavedCartsEditModalConsumer;
